export default __webpack_public_path__ + "static/media/wechat-pay.01bc879e.png";